'use client'

import { useState } from 'react'

import styled from 'styled-components'

import type { ProductListItem } from '../../api/generated'
import { breakpoints } from '../breakPoints'
import { ProductListCard, type ProductListCardVariant } from './ProductListCard'

export interface ProductCardsListProps {
  badgeImageUrl?: string
  getProductHref?: (product: ProductListItem) => string
  products: ProductListItem[]
  variant?: ProductListCardVariant
}

export function ProductCardsList({
  badgeImageUrl,
  getProductHref,
  products,
  variant = 'card',
}: ProductCardsListProps) {
  const [favoriteProductIds, setFavoriteProductIds] = useState<number[]>([])

  return (
    <List $variant={variant}>
      {products.map((product, index) => (
        <ProductListCard
          badgeImageUrl={badgeImageUrl}
          href={getProductHref?.(product)}
          isFavorite={Boolean(product.productId && favoriteProductIds.includes(product.productId))}
          key={product.productId || index}
          onFavoriteChange={(currentProduct, isFavorite) => {
            const productId = currentProduct.productId

            if (!productId) return

            setFavoriteProductIds(currentIds =>
              isFavorite
                ? [...currentIds.filter(id => id !== productId), productId]
                : currentIds.filter(id => id !== productId)
            )
          }}
          product={product}
          variant={variant}
        />
      ))}
    </List>
  )
}

const List = styled.div<{ $variant: ProductListCardVariant }>`
  display: flex;
  flex-direction: ${({ $variant }) => ($variant === 'row' ? 'column' : 'row')};
  flex-wrap: ${({ $variant }) => ($variant === 'card' ? 'wrap' : 'nowrap')};
  align-items: flex-start;
  gap: ${({ $variant }) => ($variant === 'card' ? '12px' : '32px')};
  width: 100%;
  max-width: 1280px;
  min-width: ${({ $variant }) => ($variant === 'row' ? '849px' : '0')};
  margin-inline: auto;

  @media (width < ${breakpoints.productCardsDesktopMin}) {
    flex-direction: column;
    flex-wrap: nowrap;
    gap: 24px;
    min-width: 0;
  }
`
